import { WorkflowCategory } from "../types";

interface Props {
  search: string;
  setSearch: (v: string) => void;
  category: string;
  setCategory: (v: string) => void;
  sort: string;
  setSort: (v: string) => void;
}

export default function WorkflowFilters({
  search,
  setSearch,
  category,
  setCategory,
  sort,
  setSort,
}: Props) {
  return (
    <div className="sticky top-0 z-20 bg-neutral-950 border-b border-neutral-800 p-4 flex flex-wrap gap-4">
      <input
        type="text"
        placeholder="Search workflows..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="flex-1 bg-neutral-900 border border-neutral-700 rounded-lg px-4 py-2 text-sm"
      />

      <select
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        className="bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2 text-sm"
      >
        <option value="">All Categories</option>
        <option value="Social">Social</option>
        <option value="Email">Email</option>
        <option value="AI">AI</option>
        <option value="CRM">CRM</option>
      </select>

      <select
        value={sort}
        onChange={(e) => setSort(e.target.value)}
        className="bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2 text-sm"
      >
        <option value="popular">Popular</option>
        <option value="newest">Newest</option>
        <option value="mostUsed">Most Used</option>
      </select>
    </div>
  );
}
